import { FileSpreadsheet } from 'lucide-react'
import { OnScreenModal } from '@/components/ui/OnScreenModal'
import styles from './PaymentLedgerFinalLedgerDialog.module.css'

/** Angular `confirm-dialog` with `description === 'final_ledger'`. Shared by both resident and reimbursement modules. */
export function PaymentLedgerFinalLedgerDialog({
  isOpen,
  onChoose,
  onDismiss,
}: {
  isOpen: boolean
  /** User clicked Yes (final) or No (not final). */
  onChoose: (isFinal: boolean) => void
  /** Close / backdrop / X without attaching file */
  onDismiss: () => void
}) {
  return (
    <OnScreenModal
      isOpen={isOpen}
      title="Payment Ledger"
      onClose={onDismiss}
      maxWidth="max-w-xl"
      overlayDataTestId="payment-ledger-final-ledger-dialog-overlay"
      closeButtonDataTestId="payment-ledger-final-ledger-dialog-close-button"
      footer={
        <div className={styles.footer}>
          <button
            type="button"
            onClick={() => onChoose(false)}
            data-testid="payment-ledger-final-ledger-dialog-no-button"
            className={styles.noButton}
          >
            No
          </button>
          <button
            type="button"
            onClick={() => onChoose(true)}
            data-testid="payment-ledger-final-ledger-dialog-yes-button"
            className={styles.yesButton}
          >
            Yes
          </button>
        </div>
      }
    >
      <div className={styles.body}>
        <div className={styles.headingRow}>
          <span className={styles.headingIcon} aria-hidden="true">
            <FileSpreadsheet className="h-6 w-6" />
          </span>
          <h4 className={styles.headingTitle}>Is this the Final Ledger?</h4>
        </div>
        <div className={styles.noteBox}>
          <p>
            <strong>NOTE:</strong> We have requested the resident&apos;s current payment ledger for
            this reimbursement so that the review process may begin.
          </p>
          <p>
            We accept payment ledgers throughout the review process yet require the Final Ledger
            once the resident is out of the unit.
          </p>
          <p>
            All payment ledgers will be rejected until the Final Ledger is received. This does not
            mean that the reimbursement is denied.
          </p>
          <p>It simply means that the Final Ledger requirement has not been met.</p>
        </div>
      </div>
    </OnScreenModal>
  )
}
